/* COASTA Seasonal Campaign System V1 */
(() => {
  const cfg = window.__COASTA_SEASONAL__ || {};
  const root = document.documentElement;

  const parseDate = (value) => {
    if (!value) return null;
    const time = Date.parse(value);
    return Number.isFinite(time) ? time : null;
  };

  const isActive = () => {
    if (!cfg.enabled) return false;
    if (!cfg.scheduleEnabled) return true;
    const now = Date.now();
    const start = parseDate(cfg.start);
    const end = parseDate(cfg.end);
    if (start !== null && now < start) return false;
    if (end !== null && now > end) return false;
    return true;
  };

  const applyState = () => {
    const previous = root.dataset.coastaSeasonActive;
    const active = isActive();
    root.dataset.coastaSeasonActive = active ? 'true' : 'false';
    root.dataset.coastaSeason = active ? (cfg.type || 'halloween') : 'off';
    root.dataset.coastaSeasonDecoration = active ? (cfg.decorationIntensity || 'light') : 'off';
    root.dataset.coastaSeasonFooterAccent = active && cfg.footerAccent ? 'true' : 'false';
    root.dataset.coastaSeasonAnnouncement = active && cfg.announcementEnabled ? 'true' : 'false';
    if (document.body) {
      document.body.dataset.coastaSeason = root.dataset.coastaSeason;
      document.body.dataset.coastaSeasonActive = root.dataset.coastaSeasonActive;
    }
    if (previous && previous !== root.dataset.coastaSeasonActive) {
      window.dispatchEvent(new CustomEvent('coasta:seasonalchange', { detail: { active } }));
    }
    return active;
  };

  const initAnnouncement = () => {
    const host = document.querySelector('[data-coasta-seasonal-announcement]');
    if (!host) return;
    const messages = [...host.querySelectorAll('[data-seasonal-announcement-message]')].filter(el => el.textContent.trim());
    if (messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let index = 0;
    let timer = null;
    const show = (next) => {
      messages.forEach((item, i) => item.classList.toggle('is-active', i === next));
    };
    const start = () => {
      if (timer) return;
      timer = window.setInterval(() => {
        index = (index + 1) % messages.length;
        show(index);
      }, 4000);
    };
    const stop = () => { window.clearInterval(timer); timer = null; };
    host.addEventListener('mouseenter', stop);
    host.addEventListener('mouseleave', start);
    show(0);
    start();
  };

  let countdownTimer = null;
  const initCountdowns = () => {
    const update = () => {
      const nodes = [...document.querySelectorAll('[data-seasonal-countdown]')];
      if (!nodes.length) return;
      const now = Date.now();
      nodes.forEach(node => {
        const end = parseDate(node.dataset.end);
        if (end === null) { node.hidden = true; return; }
        node.hidden = false;
        const diff = end - now;
        if (diff <= 0) { node.innerHTML = '<strong>EVENT ENDED</strong>'; return; }
        const minutesTotal = Math.floor(diff / 60000);
        const hoursTotal = Math.floor(minutesTotal / 60);
        if (hoursTotal <= 24) {
          const hours = Math.max(0, hoursTotal);
          const mins = Math.max(0, minutesTotal % 60);
          node.innerHTML = '<span>ENDS IN</span><strong>' + hours + 'H ' + mins + 'M</strong>';
          return;
        }
        const days = Math.floor(hoursTotal / 24);
        const hours = hoursTotal % 24;
        node.innerHTML = '<span>ENDS IN</span><strong>' + days + 'D ' + hours + 'H</strong>';
      });
    };
    update();
    if (!countdownTimer) countdownTimer = window.setInterval(update, 60000);
  };

  const boot = () => {
    applyState();
    initAnnouncement();
    initCountdowns();
    window.setInterval(applyState, 60000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', () => {
    applyState();
    initAnnouncement();
    initCountdowns();
  });
})();
